/* Kozie — delivery card behaviour
   1. Upsell add-to-basket, enhancing a plain form POST.
   2. Keeping the product-page card in step with the basket. That card is
      rendered server-side from cart state, so without this it stays stale until
      the shopper navigates away and back. */
(function () {
  'use strict';

  // The tag is emitted by kozie-assets.liquid, which both components render, so
  // it can appear more than once on a page. Bind listeners only the first time.
  if (window.__kozieDeliveryReady) return;
  window.__kozieDeliveryReady = true;

  // Tells the stylesheet the gift checkbox is now backed by a handler.
  document.documentElement.classList.add('kozie-js');

  var PRODUCT_SECTION = 'kozie-delivery-product';
  var CARD = '.kozie-delivery--product';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* --- keep the product-page card current -------------------------------

     pageCard(), not document.querySelector(CARD).

     A quick-add pop-up fetches the product page and injects the whole
     product-info block, delivery card included — quick-add.css hides it, but it
     is in the DOM. A bare querySelector finds THAT copy first on a collection
     page or the home page, and then this function fetched
     `/?sections=kozie-delivery-product` — the CURRENT page's URL, which is not a
     product page — on every cart update, and pasted a 5KB product-less card over
     the hidden one. Measured: 200 OK, 4,998 bytes, once per cart update for as
     long as the pop-up is open. Never visible, always wasted.

     The pop-up's card is never the one to refresh: it is hidden by design, and
     it is thrown away when the pop-up closes. Only the page's own card counts. */
  function pageCard() {
    var cards = document.querySelectorAll(CARD);
    for (var i = 0; i < cards.length; i += 1) {
      if (!cards[i].closest('quick-add-modal')) return cards[i];
    }
    return null;
  }

  function refreshProductCard() {
    if (!pageCard()) return;

    fetch(window.location.pathname + '?sections=' + PRODUCT_SECTION)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var html = data[PRODUCT_SECTION];
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(CARD);
        var live = pageCard();
        if (fresh && live) live.replaceWith(fresh);
      })
      .catch(function () { /* leave the existing card in place */ });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshProductCard);
  }

  /* --- upsell paging ------------------------------------------------------
     Delegated, because the drawer replaces this markup on every basket change.
     Scroll does not bubble, so the position listener runs in the capture phase. */
  function stepFor(list) {
    var item = list.querySelector('.kozie-upsell__item');
    if (!item) return 0;
    return item.offsetWidth + (parseFloat(getComputedStyle(list).columnGap) || 0);
  }

  /* Paging animates here rather than through CSS scroll-behavior.

     The animation is a nicety; landing on the right item is the requirement. So
     this never lets the animation decide the outcome: whatever happens to the
     tween, a timer puts the scroller on the target. That matters because an
     animated scroll — CSS smooth or a rAF tween alike — simply does not run when
     the page is not visible, and can be throttled or interrupted in ways that are
     awkward to reproduce. Belt and braces, for four lines.

     Honours prefers-reduced-motion by jumping straight there. */
  var GLIDE_MS = 320;

  function glideTo(list, target) {
    if (list.__kozieGlide) cancelAnimationFrame(list.__kozieGlide);
    if (list.__kozieLand) clearTimeout(list.__kozieLand);

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var from = list.scrollLeft;
    var delta = target - from;

    if (!delta || reduce || typeof requestAnimationFrame !== 'function') {
      list.scrollLeft = target;
      list.__kozieGlide = null;
      return;
    }

    var started = performance.now();

    function frame(now) {
      var p = Math.min(1, (now - started) / GLIDE_MS);
      // easeInOutCubic
      var eased = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      list.scrollLeft = from + delta * eased;
      if (p < 1) list.__kozieGlide = requestAnimationFrame(frame);
      else list.__kozieGlide = null;
    }

    list.__kozieGlide = requestAnimationFrame(frame);

    // The tween did not finish — hidden tab, throttled frames, whatever. Land anyway.
    list.__kozieLand = setTimeout(function () {
      if (list.__kozieGlide) {
        cancelAnimationFrame(list.__kozieGlide);
        list.__kozieGlide = null;
      }
      if (Math.abs(list.scrollLeft - target) > 1) list.scrollLeft = target;
    }, GLIDE_MS + 120);
  }

  function markDot(list, index) {
    var root = list.closest('[data-kozie-upsell]');
    var dots = root && root.querySelectorAll('.kozie-upsell__dot');
    if (!dots || !dots.length) return;
    index = Math.max(0, Math.min(index, dots.length - 1));
    for (var i = 0; i < dots.length; i++) {
      if (i === index) dots[i].setAttribute('data-active', '');
      else dots[i].removeAttribute('data-active');
    }
  }

  /* Reading the position back is right for a swipe, where the shopper decides
     where it lands. It is the wrong dependency for the arrows: it makes the
     indicator rely on a scroll event being delivered, and on the tween having
     finished by the time it is. The arrows already know which page they asked
     for, so they say so directly — see the call after glideTo(). */
  function syncDots(list) {
    var step = stepFor(list);
    markDot(list, step > 0 ? Math.round(list.scrollLeft / step) : 0);
  }

  document.addEventListener('click', function (event) {
    var prev = event.target.closest('[data-kozie-upsell-prev]');
    var next = event.target.closest('[data-kozie-upsell-next]');
    if (!prev && !next) return;

    var root = (prev || next).closest('[data-kozie-upsell]');
    var list = root && root.querySelector('[data-kozie-upsell-list]');
    if (!list) return;

    var step = stepFor(list);
    if (!step) return;

    var max = list.scrollWidth - list.clientWidth;
    var target = list.scrollLeft + (next ? step : -step);

    // Wrap, so the arrows never dead-end on the first or last suggestion.
    if (target > max + 1) target = 0;
    else if (target < -1) target = max;

    glideTo(list, target);
    markDot(list, Math.round(target / step));
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var list = event.target;
      if (list && list.nodeType === 1 && list.matches && list.matches('[data-kozie-upsell-list]')) {
        syncDots(list);
      }
    },
    true
  );

  /* --- which basket is this control on? -----------------------------------
     <cart-drawer> is rendered by theme.liquid on EVERY page, the cart page
     included, so "does a drawer exist" cannot decide which basket a control
     belongs to — on /cart it always said yes, and every update went to the
     hidden drawer while the page the shopper was looking at stayed stale.
     Ask where the control actually is instead.

     Both hosts expose Dawn's own getSectionsToRender(), so the section ids,
     names and selectors come from Dawn rather than being restated here — the
     cart page's section names are the template's ("cart-items", "cart-footer"),
     not the file names, which is the other half of the same trap. */
  function surfaceFor(element) {
    if (element.closest('#main-cart-footer, #main-cart-items')) {
      var page = document.querySelector('cart-items');
      if (page && typeof page.getSectionsToRender === 'function') {
        return { kind: 'cart', host: page };
      }
    }

    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      return { kind: 'drawer', host: drawer };
    }

    return null;
  }

  /* Dawn's two hosts disagree on the key, and the difference is silent:
       CartItems  -> { id: 'main-cart-items', section: 'cart-items', selector }
       CartDrawer -> { id: 'cart-drawer', selector }        // the id IS the name
     Reading .section alone gave [undefined, undefined], which join()s to ","
     — a request that asks the cart API for no sections at all. The basket still
     changed; the drawer just never repainted. */
  function sectionNameOf(section) {
    return section.section || section.id;
  }

  function sectionsFor(surface) {
    return surface.host
      .getSectionsToRender()
      .map(sectionNameOf)
      .filter(Boolean)
      .join(',');
  }

  function renderInto(surface, state) {
    // If we cannot repaint, reload. The basket has already changed server-side,
    // and showing one thing while charging another is the one outcome to avoid.
    if (!state.sections || !Object.keys(state.sections).length) {
      window.location.reload();
      return;
    }

    if (surface.kind === 'drawer') {
      surface.host.renderContents(state);
      return;
    }

    // Emptying the basket from this page changes more than the sections — Dawn
    // swaps in its empty state and its own classes. Let the page reload rather
    // than half-render it.
    if (state.item_count === 0) {
      window.location.reload();
      return;
    }

    var sections = state.sections || {};
    surface.host.getSectionsToRender().forEach(function (section) {
      var host = document.getElementById(section.id);
      var html = sections[sectionNameOf(section)];
      if (!host || !html) return;

      var target = host.querySelector(section.selector) || host;
      var fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(section.selector);
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
  }

  /* --- upsell size menu ---------------------------------------------------
     "+ Add" on a product with more than one size opens a small menu; picking a
     size sets the card's <select> and submits, so the add path below is reached
     unchanged and there is only ever one place that talks to cart/add.js.

     WHY THE MENU IS NOT IN THE CARD. .kozie-upsell__list scrolls horizontally,
     which makes it a clipping context vertically as well, so a panel positioned
     inside a card is cut off at the card's edge. The panel is a sibling of the
     list and is positioned over the button that opened it.

     Everything is delegated from `document`: the drawer re-renders its whole
     markup on every cart change, so anything bound to an element would be bound
     to a corpse after the first add. */
  function upsellMenu(root) {
    return root && root.querySelector('[data-kozie-upsell-menu]');
  }

  function closeUpsellMenu(root) {
    var menu = upsellMenu(root);
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    var opener = root.querySelector('[data-kozie-upsell-pick][aria-expanded="true"]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus();
    }
  }

  function openUpsellMenu(button) {
    var root = button.closest('[data-kozie-upsell]');
    var menu = upsellMenu(root);
    var form = button.closest('.kozie-upsell__form');
    var select = form && form.querySelector('.kozie-upsell__select');
    var box = menu && menu.querySelector('[data-kozie-upsell-menu-options]');
    if (!menu || !select || !box) return false;

    box.textContent = '';
    Array.prototype.forEach.call(select.options, function (option) {
      if (!option.value) return; // the "Size" placeholder is not a choice
      var choice = document.createElement('button');
      choice.type = 'button';
      choice.className = 'kozie-upsell__choice';
      choice.textContent = option.textContent.trim();
      choice.value = option.value;
      if (option.disabled) choice.disabled = true;
      if (option.value === select.value) choice.setAttribute('aria-current', 'true');
      box.appendChild(choice);
    });
    if (!box.children.length) return false;

    /* Remember which form to submit: the menu is shared by every card. */
    menu.kozieForm = form;

    /* Positioned against the panel, which is the offset parent — the button's
       own card is inside a scroller and its position moves with it. */
    menu.hidden = false;
    var origin = menu.offsetParent || menu.parentElement;
    var o = origin.getBoundingClientRect();
    var b = button.getBoundingClientRect();
    var m = menu.getBoundingClientRect();

    var left = b.left - o.left + b.width / 2 - m.width / 2;
    var max = o.width - m.width;
    if (left < 0) left = 0;
    if (left > max) left = max > 0 ? max : 0;

    menu.style.left = left + 'px';
    menu.style.top = b.top - o.top - m.height - 8 + 'px';

    button.setAttribute('aria-expanded', 'true');
    var first = box.querySelector('.kozie-upsell__choice:not([disabled])');
    if (first) first.focus();
    return true;
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-kozie-upsell-pick]');
    if (opener) {
      /* The button is type="submit" in the markup so it still works with no
         JavaScript. With the menu available, the tap opens it instead. */
      event.preventDefault();
      var root = opener.closest('[data-kozie-upsell]');
      var menu = upsellMenu(root);
      if (menu && !menu.hidden && opener.getAttribute('aria-expanded') === 'true') {
        closeUpsellMenu(root);
      } else {
        if (menu && !menu.hidden) closeUpsellMenu(root);
        openUpsellMenu(opener);
      }
      return;
    }

    var choice = event.target.closest && event.target.closest('.kozie-upsell__choice');
    if (choice) {
      var host = choice.closest('[data-kozie-upsell-menu]');
      var form = host && host.kozieForm;
      var sel = form && form.querySelector('.kozie-upsell__select');
      if (!sel) return;
      sel.value = choice.value;
      closeUpsellMenu(choice.closest('[data-kozie-upsell]'));
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      return;
    }

    /* Anywhere else closes it. */
    document.querySelectorAll('[data-kozie-upsell-menu]:not([hidden])').forEach(function (m) {
      closeUpsellMenu(m.closest('[data-kozie-upsell]'));
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-kozie-upsell-menu]:not([hidden])').forEach(function (m) {
      closeUpsellMenu(m.closest('[data-kozie-upsell]'));
    });
  });

  /* --- upsell add-to-basket ---------------------------------------------- */
  function showAddError(form, text) {
    var body = form.parentElement || form;
    var note = body.querySelector('[data-kozie-upsell-error]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'kozie-upsell__error';
      note.setAttribute('data-kozie-upsell-error', '');
      note.setAttribute('role', 'status');
      form.insertAdjacentElement('afterend', note);
    }
    note.textContent = text || 'Could not add that just now — please try again.';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.kozie-upsell__form');
    if (!form) return;

    var surface = surfaceFor(form);
    if (!surface) return; // no basket we can refresh: let the form post normally

    event.preventDefault();

    var button = form.querySelector('.kozie-upsell__button');
    var variantId = form.querySelector('[name="id"]');
    if (!variantId) return;

    // A size still to be chosen: let the browser show its own prompt rather
    // than posting an empty id.
    if (!variantId.value) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      return;
    }

    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: variantId.value, quantity: 1 }],
        sections: sectionsFor(surface),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        /* cart/add.js reports ordinary business failures — sold out, more than
           is available — with a status on a 200-shaped body. Those used to land
           in the catch below and be answered with a native form.submit(), which
           is a full page POST to /cart/add: Shopify replies with its own bare
           error page, so a shopper who tapped Add on something that had just
           sold out was thrown out of the basket entirely. The row can be
           reached in that state because the page is server-rendered and the
           drawer is long-lived — stock moves between render and tap. Say so in
           place instead, and leave them where they were. */
        if (data.status) {
          showAddError(form, data.description || data.message);
          return;
        }
        renderInto(surface, data);
        // This path does not go through product-form.js, so nothing publishes
        // cartUpdate for us — refresh the product card directly.
        refreshProductCard();
      })
      .catch(function () { showAddError(form, null); })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-busy');
          button.disabled = false;
        }
      });
  });

  /* --- "Make it gift ready" ----------------------------------------------
     The checkbox adds or removes a real gift-wrap product, so the fee lands on
     the order the courier collects against. Delegated, because both the drawer
     and the cart page replace this markup on every basket change. */
  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-kozie-gift-toggle]');
    if (!input) return;

    var surface = surfaceFor(input);
    if (!surface) {
      // Nothing we can refresh, so do not silently change what they will pay.
      input.checked = !input.checked;
      return;
    }

    var row = input.closest('[data-kozie-gift]');
    if (row) row.setAttribute('data-busy', '');

    var body = { sections: sectionsFor(surface), sections_url: window.location.pathname };
    var url;

    if (input.checked) {
      url = root() + 'cart/add.js';
      body.items = [{ id: input.getAttribute('data-variant-id'), quantity: 1 }];
    } else {
      var key = input.getAttribute('data-line-key');
      if (!key) {
        // The row has not caught up with the basket yet; the render that is
        // already in flight will restore the right state.
        if (row) row.removeAttribute('data-busy');
        return;
      }
      url = root() + 'cart/change.js';
      body.id = key;
      body.quantity = 0;
    }

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Could not update the basket');
        renderInto(surface, data);

        // Nothing else publishes for this path; let the rest of the theme know.
        //
        // QA 13 Sep 2026 — renderInto paints exactly ONE surface: the drawer, or
        // the cart page, whichever the shopper is on. The other one is genuinely
        // stale and does need this event. What it does NOT need is a second pass
        // over the surface just painted — measured live, one gift tick fired
        // /cart/add.js plus BOTH section fetches and 97 DOM insertion batches,
        // destroying and recreating the checkbox under the shopper's finger.
        // So say which surface is already done and let cart.js skip that one.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kozie-gift', kozieRendered: surface.kind });
        } else {
          refreshProductCard();
        }
      })
      .catch(function () {
        // Put the box back where it was rather than leaving it lying about the
        // basket, then let the shopper try again.
        input.checked = !input.checked;
      })
      .finally(function () {
        if (row) row.removeAttribute('data-busy');
      });
  });
})();
